module.exports = __webpack_public_path__ + "img/max-cloud-transfer.a22c7faa.svg";